import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"LabelsHeaderCell"}}
export type LabelsHeaderCellQueryVariables = Types.Exact<{
  idOrg: Types.Scalars['ID'];
  idBoards: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type LabelsHeaderCellQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & { boards: Array<(
      { __typename: 'Board' }
      & { labels: Array<(
        { __typename: 'Label' }
        & Pick<Types.Label, 'id' | 'name' | 'color'>
      )> }
    )> }
  )>, member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id'>
    & { prefs?: Types.Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Types.Member_Prefs, 'colorBlind'>
    )> }
  )> }
);


export const LabelsHeaderCellDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabelsHeaderCell"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idOrg"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idOrg"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoards"}}},{"kind":"Argument","name":{"kind":"Name","value":"boardLabelsLimit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colorBlind"}}]}}]}}]}}]};

/**
 * __useLabelsHeaderCellQuery__
 *
 * To run a query within a React component, call `useLabelsHeaderCellQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelsHeaderCellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelsHeaderCellQuery({
 *   variables: {
 *      idOrg: // value for 'idOrg'
 *      idBoards: // value for 'idBoards'
 *   },
 * });
 */
export function useLabelsHeaderCellQuery(baseOptions: Apollo.QueryHookOptions<LabelsHeaderCellQuery, LabelsHeaderCellQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabelsHeaderCellQuery, LabelsHeaderCellQueryVariables>(LabelsHeaderCellDocument, options);
      }
export function useLabelsHeaderCellLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabelsHeaderCellQuery, LabelsHeaderCellQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabelsHeaderCellQuery, LabelsHeaderCellQueryVariables>(LabelsHeaderCellDocument, options);
        }
export type LabelsHeaderCellQueryHookResult = ReturnType<typeof useLabelsHeaderCellQuery>;
export type LabelsHeaderCellLazyQueryHookResult = ReturnType<typeof useLabelsHeaderCellLazyQuery>;
export type LabelsHeaderCellQueryResult = Apollo.QueryResult<LabelsHeaderCellQuery, LabelsHeaderCellQueryVariables>;